import ConfigurationClient from './features/Configuration/services/configurationClient';
import ConfigurationService from './features/Configuration/services/configurationService';
import CSVLocationsFileClient from './features/Configuration/services/csvLocationsFileClient';
import CSVLocationsFileService from './features/Configuration/services/csvLocationsFileService';
import LoginService from './features/login/LoginService';
import MetadataClient from './features/Monitor/services/metadataClient';
import MetadataService from './features/Monitor/services/metadataService';
import MonitorsClient from './features/Monitor/services/monitorsClient';
import MonitorsService from './features/Monitor/services/monitorsService';
import OutreachClient from './features/Monitor/services/outreachClient';
import OutreachService from './features/Monitor/services/outreachService';
import IntrospectClient from './features/Signal/services/IntrospectClient';
import IntrospectService from './features/Signal/services/IntrospectService';
import VersionClient from './services/VersionClient';
import VersionService from './services/VersionService';

export class DependencyContainer {
  // services
  loginService = new LoginService(this);
  introspectService = new IntrospectService(this);
  metadataService = new MetadataService(this);
  monitorsService = new MonitorsService(this);
  csvLocationsFileService = new CSVLocationsFileService(this);
  versionService = new VersionService(this);
  outreachService = new OutreachService(this);
  configurationService = new ConfigurationService(this);

  // clients
  introspectClient = new IntrospectClient(this);
  metadataClient = new MetadataClient(this);
  monitorsClient = new MonitorsClient(this);
  csvLocationsFileClient = new CSVLocationsFileClient(this);
  versionClient = new VersionClient(this);
  outreachClient = new OutreachClient(this);
  configurationClient = new ConfigurationClient(this);
}
